<main>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    Meus Depositos
                </div>
            </div>
        </div>

        <div class="separador-2"></div>

        
    </div>
</main>

<div class="container">
    <div class="row">
        <div class="card col-2" (click)="NavegarParaTransferencias()">
            <p>Transferência PIX</p>
            <img src="../../../../../../assets/icons/financeiro/transaction.svg" class="custom-icon1" />
        </div>

        <div class="card col-2 offset-1" (click)="NavegarParaBoletos()">
            <p>Boleto</p>
            <img src="../../../../../../assets/icons/financeiro/bill.svg" class="custom-icon2" />
        </div>
    </div>
</div>